// -------------------------------------
// Headroom
// -------------------------------------
// (function($) {

jQuery(window).on("load", function() {

  $(window).on("resize", function() {

    var $navbar = $("#mainNav");
    var $height = $navbar.height();

    // Set wrapper height as placeholder
    $navbar.parent().css("min-height", $height);

    var $offset = $navbar.offset().top;

    var options = {
      offset: $offset,
      // tolerance: $height,
      classes: {
        // when element is initialised
        initial: "headroom",
        // when scrolling up
        pinned: "headroom--pinned",
        // when scrolling down
        unpinned: "headroom--unpinned",
        // when above offset
        top: "headroom--top",
        // when below offset
        notTop: "headroom--not-top",
        // when at bottom of scoll area
        bottom: "headroom--bottom",
        // when not at bottom of scroll area
        notBottom: "headroom--not-bottom"
      },
      // callback when pinned, `this` is headroom object
      onPin: function() {},
      // callback when unpinned, `this` is headroom object
      onUnpin: function() {
        // $navbar.children(".navbar-toggler").removeClass("is-active");
        // Bootstrap Collapse
        // $navbar.children(".navbar-collapse").collapse("hide");
      },
      // callback when above offset, `this` is headroom object
      onTop: function() {
        // $navbar.parent().css("height", "auto");
      },
      // callback when below offset, `this` is headroom object
      onNotTop: function() {
        // $navbar.parent().height($height);
      },
      // callback at bottom of page, `this` is headroom object
      onBottom: function() {},
      // callback when moving away from bottom of page, `this` is headroom object
      onNotBottom: function() {}
    }

    $navbar.headroom(options);

  }).resize();

});

// })(jQuery);
console.log("test");